export const bankAndSuperDefaults = {
  paymentMethod: 'Bank',
  accountName: '',
  bank: '',
  bsb: '',
  accountNumber: '',
  superFundType: 'Regulated super fund',
  superContributionRate: '12',
  superCompany: '',
  smsfsName: '',
  smsfsAbn: '',
  electronicServiceAddress: '',
  employerNumber: '',
  smsfsBankAccountName: '',
  smsfsBsb: '',
  smsfsAccountNumber: ''
};

export const employeeDetailsDefaults = {
  personal: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    gender: 'Male',
    address1: '',
    address2: '',
    suburb: '',
    state: 'NSW',
    postcode: ''
  },
  bankAndSuper: bankAndSuperDefaults,
  employment: {
    jobTitle: '',
    startDate: null,
    employmentType: '',
    weeklyWorkHours: '',
    roles: '',
    payPeriod: '',
    leaveLoading: ''
  },
  payRates: {
    basePayRate: '',
    basePayRateType: 'hour',
    saturdayRate: '',
    saturdayRateType: 'hour',
    sundayRate: '',
    sundayRateType: 'hour',
    publicHolidayRate: '',
    publicHolidayRateType: 'hour',
    additionalPublicHoliday: '',
    additionalPublicHolidayRateType: 'hour',
    nightShiftRate: '',
    nightShiftRateType: 'hour',
    nightShiftStartTime: '',
    nightShiftEndTime: '',
    holidays: []
  },
  tax: {
    dateOfBirth: '',
    statusOfResidency: 'Australian resident',
    incomeType: 'SAW (Salary and wages)',
    tfnExemption: 'No TFN quoted',
    taxFileNumber: '',
    claimTaxFreeThreshold: false,
    hasStudyAndTrainingLoan: false,
    isHorticulturistOrShearer: false,
    hasChildSupportObligations: false
  },
  openingBalances: {
    asAtDate: '2025-08-01',
    leaveBalances: {
      annualLeaveBalance: 0.0,
      sickLeaveBalance: 0.0
    },
    ordinaryEarnings: {
      ordinaryTimeEarnings: 0,
      superGuarantee: 0,
      tax: 0,
      bonusesCommission: 0,
      directorsFee: 0,
      employerContributionsRESC: 0,
      superSalarySacrifice: 0,
      reimbursement: 0,
      overtime: 0
    },
    paidLeave: {
      annualLeave: 0,
      sickLeave: 0,
      longServiceLeave: 0,
      paidParentalLeave: 0,
      ancillaryAndDefenceLeave: 0,
      workersCompensation: 0
    },
    allowance: {
      awardTransportPayments: 0,
      centsPerKM: 0,
      laundry: 0,
      overtimeMeal: 0,
      qualifications: 0,
      task: 0,
      tool: 0,
      travel: 0,
      jobKeeperTopUp: 0,
      otherGeneral: 0,
      otherHomeOffice: 0,
      otherNonDeductible: 0,
      otherTransportFares: 0,
      otherUniform: 0,
      otherPrivateVehicle: 0
    },
    deductions: {
      preTaxFees: 0,
      preTaxWorkplaceGiving: 0,
      postTaxFees: 0,
      postTaxWorkplaceGiving: 0,
      childSupportGarnishees: 0,
      childSupportDeductions: 0
    },
    fringeBenefits: {
      fringeBenefitsTaxable: 0
    }
  },
  template: {
    ordinaryTimeEarnings: {
      hours: 76,
      amount: 777
    },
    earnings: [
      {
        type: 'Bonus',
        exemptFromSuper: false,
        amount: 0
      }
    ],
    extraHours: [
      {
        option: 'Ordinary hours - Accrued leave',
        name: '',
        hours: 0,
        rate: 0
      }
    ],
    allowances: [
      {
        unit: 0,
        rate: 0,
        option: 'Subject to tax and super',
        type: 'Cents per km'
      }
    ],
    deductions: [
      {
        option: 'Pre-tax deduction',
        type: 'Fee',
        rate: 0
      }
    ],
    childSupport: [
      {
        type: 'Child support garnishees',
        rate: 0
      }
    ],
    superannuation: {
      employerContribution: 0,
      superSalarySacrifice: 0,
      isPercentage: false
    },
    fixedTaxAmount: {
      enabled: false,
      amount: 0
    }
  }
};
